import React, { useState, useEffect, useRef } from 'react';
import '../../css/earnBalance.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButtonSelectOption from '../../components/CustomButtonSelectOption';
import SeePartners from '../../components/EarnBalanceSwithSelector/SeePartners';
import ActivateOffers from '../../components/EarnBalanceSwithSelector/ActivateOffers';
import InviteFriends from '../../components/EarnBalanceSwithSelector/InviteFriends';
import Heading from '../../components/Heading';
import GifAnim from '../../components/GifAnim';
import CustomButtonSelectOptionView from '../../components/CustomButtonSelectOptionView';
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';
import { useSelector, useDispatch } from 'react-redux';
import { setCategoryState } from '../../features/onboardingData/onboardingUserData';

function EarnBalance() {

    const [isLoading, setIsLoading] = useState(true);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [urlOption, setUrlOption] = useState('');
    const [selectedOption, setSelectedOption] = useState('parceiros');
    const [partnerCategory, setPartnerCategory] = useState('');

    const options = ['parceiros', 'ofertas', 'convidar-amigos'];
    const optionText = ['Ver parceiros', 'Ativar ofertas', 'Convidar amigos'];

    const [searchParams] = useSearchParams();
    const getCategory = searchParams.get("category");

    const getURL = () => {
        const fullURL = window.location.href;
        const pathSegments = new URL(fullURL).pathname.split('/');
    
        const index = pathSegments.indexOf('ganhar-saldo');
    
        if (index !== -1 && pathSegments[index + 1]) {
          const option = pathSegments[index + 1]; 
          const optionDecoded = decodeURIComponent(option);
          setUrlOption(optionDecoded);
          setSelectedOption(optionDecoded)
        }  

        if (getCategory) {
            setPartnerCategory(getCategory);
        }

    }

    useEffect(() => {
        getURL() 
    }, []);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
    };

    // const [selectedOption, setSelectedOption] = useState(
    //     localStorage.getItem('selectedOption') || 'option1'
    // );

    // useEffect(() => {
    //     localStorage.setItem('selectedOption', selectedOption);
    // }, [selectedOption]);

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    useEffect(() => {
        // Map selectedOption to corresponding URL path
        if (selectedOption !== '') {
            const optionToPathMap = {
                "parceiros": "parceiros",
                "ofertas": "ofertas",
                "convidar-amigos": "convidar-amigos"
            };

            // Get the corresponding path
            const path = optionToPathMap[selectedOption];
            // Navigate to the new URL
            if (partnerCategory !== '') {
                dispatch(setCategoryState(true));
                navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros', { state: { category: partnerCategory } });
            } else {
                navigate(`/ganhar-saldo/${path}`, { replace: true });
            }

        }

    }, [selectedOption, navigate, partnerCategory]);

    const handleBtnGoToContacts = () => {
        navigate('/configuracoes#contactMainContainer');
    };

  return (  
    <>
    <Header/> 
    { isLoading ? 
        <GifAnim />
    :
    <div className={ isTablet ? "mainViewContainerEarnBalance" : ( isMobile ? 'mainViewContainerEarnBalanceTablet' : 'mainViewContainerEarnBalanceMobile') }>
        <div className={ isTablet ? 'firstTxtViewContainerEarnBalance' : ( isMobile ? 'firstTxtViewContainerEarnBalanceTablet' : 'firstTxtViewContainerEarnBalanceMobile') }>
            <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '48px', marginTop: '-48px' } :  ( isMobile ? { width: '100%', height: '100%', paddingInline: '40px' } : { width: '100%', height: '100%', paddingInline: '16px' })}>
                { (isStatusCarteira ===  '2')  &&
                    <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                }
            </div> 
            <div className='mainHeadingViewContainerEarnBalance'> 
                <CustomBreadcrumbs hasPadding hasEarnBalance />
                <Heading hasPadding hasBtnBack={false}/>
            </div>
            <div className={ isTablet ? 'secondMainContainerEarnBalance' : ( isMobile ? 'secondMainContainerEarnBalanceTablet' : 'secondMainContainerEarnBalanceMobile') }>
                <div className={ isTablet ? 'firstSubMainContainerEarnBalance' : 'firstSubMainContainerEarnBalanceMobile' }>
                    <div className='secondTitleViewEarnBalance'>
                        <span className={ isTablet ? 'textTitleRegular400EarnBalance' : ( isMobile ? 'textTitleRegular400EarnBalanceTablet' : 'textTitleRegular400EarnBalanceMobile') }>Ganhar <span className={ isTablet ? 'textTitleBold700EarnBalance' : ( isMobile ? 'textTitleBold700EarnBalanceTablet' : 'textTitleRegular400EarnBalanceMobile') }>saldo</span></span>
                    </div>
                    <div className='txtSecondTitleViewEarnBalance'>
                        <div className='textSecondTitleViewEarnBalance'>Acumule dinheiro através de compras em parceiros, de códigos promocionais ou de recomendação a amigos.</div>
                    </div>
                </div>
            </div>
            
            <div className={ isTablet ? 'secondMainContainerTwoEarnBalance' : 'secondMainContainerTwoEarnBalanceMobile' }>
                { isTablet ?
                    <div className='swithSelectorContainerEarnBalance' style={{ marginBottom: '48px' }}>
                        <CustomButtonSelectOption 
                            text={'Ver parceiros'} 
                            onPress={() => handleOptionClick("parceiros")} 
                            isActive={selectedOption === 'parceiros'}
                        />
                        <CustomButtonSelectOption 
                            text={'Ativar ofertas'} 
                            onPress={() => handleOptionClick("ofertas")} 
                            isActive={selectedOption === 'ofertas'}
                            enabled={isStatusCarteira ===  '2'}
                            
                        />
                        <CustomButtonSelectOption 
                            text={'Convidar amigos'} 
                            onPress={() => handleOptionClick("convidar-amigos")} 
                            isActive={selectedOption === 'convidar-amigos'}
                            enabled={isStatusCarteira ===  '2'}
                        />
                    </div>
                    : ( isMobile ?
                            <div className='swithSelectorContainerEarnBalanceTablet' style={{ marginBottom: '48px' }}>
                                <CustomButtonSelectOption 
                                    text={'Ver parceiros'} 
                                    onPress={() => handleOptionClick("parceiros")} 
                                    isActive={selectedOption === 'parceiros'}
                                />
                                <CustomButtonSelectOption 
                                    text={'Ativar ofertas'} 
                                    onPress={() => handleOptionClick("ofertas")} 
                                    isActive={selectedOption === 'ofertas'}
                                    enabled={isStatusCarteira ===  '2'}
                                />
                                <CustomButtonSelectOption 
                                    text={'Convidar amigos'} 
                                    onPress={() => handleOptionClick("convidar-amigos")} 
                                    isActive={selectedOption === 'convidar-amigos'}
                                    enabled={isStatusCarteira ===  '2'}
                                />
                            </div>
                        :
                            <CustomButtonSelectOptionView 
                                options={options} 
                                optionText={optionText}
                                onOptionChange={handleOptionClick}
                            />

                    )
                }
                {/* <div className='swithSelectorDeviderLineEarnBalance'></div> */}

                <div className={ isTablet ? 'firstSubMainContainerEarnBalance' : 'firstSubMainContainerEarnBalanceMobile' }>
                    {selectedOption === "parceiros" && (
                        <SeePartners/>
                    )}
                    {selectedOption === "ofertas" && (
                        <ActivateOffers/>
                    )}
                    {selectedOption === "convidar-amigos" && (
                        <InviteFriends/>
                    )}
                </div>
            </div>   
        </div>
    </div>
    }
    <Footer/> 
    </>
  )
}

export default EarnBalance;